import { InstallationsWorkloadState } from "./state";
import { InstallationWorkload } from "@/model/data/workload/InstallationWorkload";
import { GetWorkloadReqData } from "@/model/communication/workload/GetWorkloadReqData";

export const SET_REQUEST_DATA = "SET_REQUEST_DATA";
export const SET_INSTALLATIONS_LIST = "SET_INSTALLATIONS_LIST";
export const SET_LIST_TOTAL_LENGTH = "SET_LIST_TOTAL_LENGTH";
export const SET_CURRENCIES = "SET_CURRENCIES";
export const SET_INSTALLATIONS_LIST_FETCHING = "SET_INSTALLATIONS_LIST_FETCHING";

export default {

    [SET_REQUEST_DATA](state: InstallationsWorkloadState, reqData: GetWorkloadReqData) {
        state.reqData = reqData;
    },
    [SET_INSTALLATIONS_LIST](state: InstallationsWorkloadState, installationsList: InstallationWorkload[]) {
        state.installationsList = installationsList;
    },
    [SET_LIST_TOTAL_LENGTH](state: InstallationsWorkloadState, totalInstallationsCount: number) {
        state.totalInstallationsCount = totalInstallationsCount;
    },
    [SET_CURRENCIES](state: InstallationsWorkloadState, currencies: string[]) {
        state.currencies = currencies;
    },
    [SET_INSTALLATIONS_LIST_FETCHING](state: InstallationsWorkloadState, value: boolean) {
        state.isInstallationsListFetching = value;
    }
}